import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './ExternalAppointment.module.scss';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators, compose } from 'redux';
import { requestSuccess, startRequest } from 'modules/Contacts/redux/slots/actions';
import { connect } from 'react-redux';
import {
  isAppointmentError,
  makeAppointmentSelector,
  propertySelectorFactory,
  slotsDatesSelectors,
  slotsObjectSelector,
} from 'modules/App/components/ExternalAppointment/selectors';
import ExternalAppointmentForm from './components/ExternalAppointmentForm';

import { startRequest as makeAppointment } from '../../../Contacts/redux/makeAppointment/actions';
import { set as setAppointmentDetails } from 'modules/Contacts/redux/appointments/actions';
import Appointment from 'modules/Contacts/containers/AppointmentContainer';

class ExternalAppointment extends Component {
  onSubmitHandle = (appointment) => {
    this.props.makeAppointment(appointment);
  };

  render() {
    const {
      slotDates,
      isSlotLoading,
      getSlots,
      slots,
      bookId,
      isAppointmentError,
      isMakeAppointmentLoading,
      isMakeAppointmentError,
      resetSlots,
    } = this.props;
    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <div className={styles.appointmentContainer}>
          <div className={styles.appointmentModal}>
            {!bookId ? (
              <ExternalAppointmentForm
                getSlots={getSlots}
                slotDates={slotDates}
                slots={slots}
                isSlotLoading={isSlotLoading}
                isMakeAppointmentLoading={isMakeAppointmentLoading}
                isMakeAppointmentError={isMakeAppointmentError}
                isError={isAppointmentError}
                onSubmit={this.onSubmitHandle}
                resetSlots={resetSlots}
              />
            ) : (
              <Appointment />
            )}
          </div>
        </div>
      </div>
    );
  }
}

ExternalAppointment.propTypes = {
  getSlots: PropTypes.func.isRequired,
  slotDates: PropTypes.array,
  slots: PropTypes.object,
  isSlotLoading: PropTypes.bool,
  isAppointmentError: PropTypes.bool,
  makeAppointment: PropTypes.func.isRequired,
  isMakeAppointmentLoading: PropTypes.bool,
  isMakeAppointmentError: PropTypes.string,
  bookId: PropTypes.string,
  resetSlots: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  slots: propertySelectorFactory(slotsObjectSelector, 'data'),
  slotDates: slotsDatesSelectors,
  bookId: propertySelectorFactory(makeAppointmentSelector, 'data.bookId'),
  isSlotLoading: propertySelectorFactory(slotsObjectSelector, 'loading'),
  isAppointmentError: isAppointmentError,
  isMakeAppointmentLoading: propertySelectorFactory(makeAppointmentSelector, 'loading'),
  isMakeAppointmentError: propertySelectorFactory(makeAppointmentSelector, 'error'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSlots: (taxAuthorityId, serviceId) => startRequest(taxAuthorityId, serviceId),
      makeAppointment,
      setAppointmentDetail: (bookId, data) => setAppointmentDetails({ bookId, data }),
      resetSlots: () => requestSuccess([]),
    },
    dispatch,
  );
export default compose(connect(mapStateToProps, mapDispatchToProps))(ExternalAppointment);
